module.exports = ChartDataLabels;